(function ($) {
    'use strict';

    var material, materialGroups, inputs, selects;

    material = $('.material-design');

    if (material.length <= 0)
        return false;

    materialGroups = material.find('.material-group');
    inputs = materialGroups.find('input, textarea');
    selects = materialGroups.find('select');

    materialGroups.find('br').remove();

    inputs.each(function (idx, el) {
        var that = $(el);
        var prev = that.prev();
        if (prev.is('label')){
            if (prev.text().trim() != ''){
                that.attr('placeholder', '');
            }
        }
    });

    selects.each(function (idex, el) {
        var that = $(el);
        that.closest('.material-group').addClass('hasvalue');
    });

    inputs.on('focus', function () {
        var that = $(this);
        var theBox = that.closest('.material-group');
        theBox.addClass('focusin');
    });

    inputs.on('focusout', function () {
        var that = $(this);
        var theBox = that.closest('.material-group');
        theBox.removeClass('focusin');

        $.each(inputs, function (index, input) {
            var theBoxGet = $(input).closest('.material-group');

            if ($(input).val() != ''){
                theBoxGet.addClass('hasvalue');
            }else{
                theBoxGet.removeClass('hasvalue');
            }
        });
    });

    setTimeout( function () {
        inputs.each(function (index, that) {
            if ($(that).val() != '' || $(that).is(':-webkit-autofill')){
                var theBox = $(that).closest('.material-group');
                theBox.addClass('hasvalue');
            }
        });
    }, 100 );

})(jQuery);